module.exports = __webpack_public_path__ + "img/NTFS.97019275.png";